module.exports = __webpack_public_path__ + "img/archive.1422df6b.svg";